import { useCallback, useEffect, useState } from 'react';
import { trackRecentContract } from '../../components/CommandK';
import { apiMaybe, apiRequest } from '../../services/apiClient';

export default function useContractDetailData(contractId) {
  const [contract, setContract] = useState(null);
  const [contractFiles, setContractFiles] = useState([]);
  const [activityEvents, setActivityEvents] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    if (!contractId) return;
    let cancelled = false;

    setLoading(true);
    setError(null);

    Promise.all([
      apiRequest(`/contracts/${contractId}`),
      apiMaybe(`/contracts/${contractId}/files`),
    ])
      .then(([data, files]) => {
        if (cancelled) return;
        setContract(data);
        setContractFiles(Array.isArray(files) ? files : []);
        setLoading(false);
        trackRecentContract(data);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || 'Contract not found');
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, [contractId]);

  useEffect(() => refresh(), [refresh]);

  useEffect(() => {
    if (!contractId) return undefined;
    let cancelled = false;

    apiMaybe(`/contracts/${contractId}/activity`)
      .then((data) => {
        if (cancelled || !data) return;
        setActivityEvents(Array.isArray(data.events) ? data.events : []);
      });

    return () => { cancelled = true; };
  }, [contractId]);

  return {
    activityEvents,
    contract,
    contractFiles,
    error,
    loading,
    refresh,
    setContract,
  };
}
